import { whmcs } from './whmcs';
import { aws } from './aws';
import { cpanelProxy } from './cpanelProxy';
import { rdStation } from './rdStation';
import { customerSupport } from './customerSupport';
import { external } from './external';

const api = {
  aws,
  whmcs,
  cpanelProxy,
  rdStation,
  customerSupport,
  external,
};

export default api;
